import React from "react";
import Meta from "./../components/Meta";
import LegalSection from "./../components/LegalSection";
import { useRouter } from "./../util/router";
import PageHeader from './../components/shell/PageHeader';

function LegalPage(props) {
  const router = useRouter();

  return (
    <>
      <Meta title="Legal" />
      <PageHeader back />
      <LegalSection section={router.query.section} key={router.query.section} />
    </>
  );
}

export default LegalPage;
